import Input from "../controls/Input";

export default function FilterInput(props) {
  const { header, onChange, resetFilter, valueName, value } = props;

  return (
    <div className="p-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-semibold text-[#0F172A]">{header}</p>
        <button
          type="button"
          onClick={() => resetFilter()}
          className="text-xs font-semibold text-[#2563EB] hover:text-[#1D4ED8]"
        >
          Reset
        </button>
      </div>
      <div className="mt-2">
        <Input
          onChange={(e) => {
            onChange(e.target.value);
          }}
          name={valueName}
          value={value || ""}
        />
      </div>
    </div>
  );
}
